<template>
    <el-container style="height: 100vh">
        <el-aside :style="{width:!isCollapse?'210px':'65px'}">
            <left></left>
        </el-aside>
        <el-container>
            <el-header class="index-header">
                <navigation></navigation>
            </el-header>
            <el-main style="height: 100%;background-color: #F8F8F8">
                <!-- 面包屑导航 -->
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/home/index' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item v-for="item in currentRouterName" :key="item">{{ item }}</el-breadcrumb-item>
                </el-breadcrumb>

                <router-view></router-view>
            </el-main>
        </el-container>
    </el-container>
</template>
<script>
import Left from "@/components/layout/Left";
import Navigation from "@/components/layout/Navigation";
import Bus from "@/utils/Bus";

export default {
    components: {Navigation, Left},
    data(){
        return{
            isCollapse:false
        }
    },
    computed: {
        currentRouterName() {
            if (!this.$route.name || this.$route.name === "首页") {
                return [];
            }
            return this.$route.name.split(";");
        }
    },
    mounted() {
        Bus.$on('collapsed', content => {
            console.log(content);
            this.isCollapse = content;
        });
    },
    beforeDestory() {
        Bus.$off('collapsed');
    },
}
</script>

<style scoped>
.index-header,
.index-main {
    padding: 0;

}
</style>